<div
  class="glass-house-shelf-talker-item"
  [class.larger]="cardSize === Types.ShelfTalkerCardSize.ShelfTalkerSize_Custom5x7">
  <div class="brand-logo-and-badges">
    <img
      *rxIf="
        shelfTalkerCardData | getVariantAssetForShelfTalker: variantsGroupedByBrand | push as asset;
        else noImage;
        strategy: 'immediate'
      "
      appImage
      class="brand-logo"
      [asset]="asset"
      alt="brand"
      src="" />
    <ng-template #noImage>
      <img class="brand-logo" [src]="variantsGroupedByBrand | glassHouseBrandFallback" alt="fallback" />
    </ng-template>
    <ng-container *rxLet="variantsGroupedByBrand | variantGroupedByBrandMethod: 'getBadges'; let variantBadges">
      <div *ngIf="variantBadges?.length > 0" class="badges">
        <img
          *ngFor="let variantBadge of variantBadges"
          appImage
          class="badge"
          [asset]="variantBadge?.image"
          alt="badge"
          src="" />
      </div>
    </ng-container>
  </div>
  <div class="prices-and-label">
    <div class="price-container">
      <div class="pricing-headers">
        <div class="pricing-header pre-tax">
          <div>pre tax</div>
        </div>

        <div class="pricing-header">
          <div>out</div>
          <div>the door</div>
        </div>
      </div>
      <div class="prices">
        <div class="price pre-tax">
          <app-shelf-talker-pricing
            [shelfTalkerCardData]="shelfTalkerCardData"
            [variantsGroupedByBrand]="variantsGroupedByBrand"
            [displayDecimalCharacter]="false"
            [priceStream]="Types.LocationPriceStream.Default"
            [maxWidthInPx]="cardSize === Types.ShelfTalkerCardSize.ShelfTalkerSize_Custom5x7 ? 80 : 62"
            [transparentWhileScaling]="viewingInLiveView"
            [adjustLineHeight]="false"></app-shelf-talker-pricing>
        </div>
        <div class="price out-the-door">
          <app-shelf-talker-pricing
            [shelfTalkerCardData]="shelfTalkerCardData"
            [variantsGroupedByBrand]="variantsGroupedByBrand"
            [displayDecimalCharacter]="false"
            [priceStream]="Types.LocationPriceStream.TaxesIn"
            [maxWidthInPx]="cardSize === Types.ShelfTalkerCardSize.ShelfTalkerSize_Custom5x7 ? 80 : 62"
            [transparentWhileScaling]="viewingInLiveView"
            [adjustLineHeight]="false"></app-shelf-talker-pricing>
        </div>
      </div>
    </div>
    <div>
      <app-label-inflator
        class="shelf-talker-label"
        [columnLabel]="false"
        [labelComponentInterface]="variantsGroupedByBrand"
        [reset]="false">
      </app-label-inflator>
    </div>
  </div>
</div>
